import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesSubjectRecognitionParams {
  /**
   * 待识别的图片URL地址
   */
  image_url: string;
}

export interface VolcesSubjectRecognitionResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_subject_recognition
 *
 * API Documentation: https://www.volcengine.com/docs/85621/1828975
 * 
 * Volces 主体识别-创建角色服务,用于识别图片中是否包含人物主体。识别结果: 0=无人物主体, 1=有人物主体。
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesSubjectRecognition } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesSubjectRecognition({
 *   // 参数见 VolcesSubjectRecognitionParams 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesSubjectRecognitionParams 接口定义
 * @returns 生成的资源列表
 */
export async function volcesSubjectRecognition(
  params: VolcesSubjectRecognitionParams,
): Promise<VolcesSubjectRecognitionResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_subject_recognition',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSubjectRecognitionResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
